var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full",attrs:{"id":"app"}},[_c('div',{staticClass:"sm:hidden h-full flex-col"},[_c('navbar',{attrs:{"isLoggedIn":_vm.IsLoggedIn}}),_c('router-view')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden sm:flex justify-center h-screen"},[_c('div',{staticClass:"my-auto text-3xl px-10"},[_vm._v(" Sorry, This App can only run on phones ")])])
}]

export { render, staticRenderFns }